export default "__VITE_PUBLIC_ASSET__bb6f455c__"